import React from 'react';
import type { KeyboardEventCallback, KeyboardShortcut } from './types';
import { isValidKeyboardEvent } from './helpers';

/**
 * Abstraction to easily register a component with keyboard events
 * @param keyboardShortcut - keyboard shortcut to listen to
 * @param disabled - whether the keyboard shortcut is disabled; does not register an event listener if true
 */
export function useKeyboardKeyEvent({
  shortcut,
  callback,
  enabled = true,
}: {
  shortcut: KeyboardShortcut;
  callback: KeyboardEventCallback;
  enabled?: boolean;

}) {
  React.useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      if (isValidKeyboardEvent(event, shortcut)) {
        callback(event);
      }
    }

    if (enabled) {
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      if (enabled) {
        document.removeEventListener('keydown', handleKeyDown);
      }
    };
  }, [shortcut, callback, enabled]);
}
